function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_4277_2984)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 30,
  r: 20,
  fill: "#00000A"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M46.765 41.0299C47.9765 41.0299 48.9587 35.9637 48.9587 29.7143C48.9587 23.4648 47.9765 18.3986 46.765 18.3986C45.5535 18.3986 44.5714 23.4648 44.5714 29.7143C44.5714 35.9637 45.5535 41.0299 46.765 41.0299Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8403 42.5714C41.9355 42.5714 42.8233 36.8151 42.8233 29.7143C42.8233 22.6135 41.9355 16.8571 40.8403 16.8571C39.745 16.8571 38.8572 22.6135 38.8572 29.7143C38.8572 36.8151 39.745 42.5714 40.8403 42.5714Z",
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5035 37.9469C36.176 37.9469 36.7212 34.2611 36.7212 29.7143C36.7212 25.1675 36.176 21.4816 35.5035 21.4816C34.831 21.4816 34.2858 25.1675 34.2858 29.7143C34.2858 34.2611 34.831 37.9469 35.5035 37.9469Z",
  fill: "white"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.9436 35.2103C32.228 35.2103 32.4585 32.7496 32.4585 29.7143C32.4585 26.6789 32.228 24.2183 31.9436 24.2183C31.6592 24.2183 31.4286 26.6789 31.4286 29.7143C31.4286 32.7496 31.6592 35.2103 31.9436 35.2103Z",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_4277_2984",
  x: 0,
  y: 0,
  width: 80,
  height: 80,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 10
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4277_2984"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4277_2984",
  result: "shape"
})));
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 10 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.83b7e706.svg";
export { ForwardRef as ReactComponent };